import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

/**
 * Devuelve la clave con la que un control esta registrado en su padre. Para un FormArray la clave es el indice.
 * Devuelve null si el control no esta registrado en su padre (no deberia ocurrir, pero un control huerfano no se
 * puede situar dentro del payload).
 */
function getControlKey(control: AbstractControl): string | null {
  const parent = control.parent;
  if (!parent) return null;

  if (parent instanceof FormArray) {
    const index = parent.controls.indexOf(control);
    return index >= 0 ? String(index) : null;
  }

  const controls = (parent as FormGroup).controls;
  return Object.keys(controls).find(key => controls[key] === control) ?? null;
}

/**
 * Compone la ruta del control dentro del formulario raiz, de fuera hacia dentro: ['user', 'name'].
 * Devuelve [] si algun tramo no se puede resolver, para que el helper no muestre una ruta incorrecta.
 */
export function getControlPath(control: AbstractControl): string[] {
  const segments: string[] = [];
  let current: AbstractControl | null = control;

  while (current?.parent) {
    const key = getControlKey(current);
    if (key === null) return [];
    segments.unshift(key);
    current = current.parent;
  }

  return segments;
}

/**
 * Construye el objeto de ejemplo anidado a partir de la ruta del campo. Un tramo numerico genera un array,
 * de forma que ['receivers', '0', 'id'] produce {receivers: [{id: ...}]}.
 */
export function buildPayloadExample(segments: string[], value: unknown): unknown {
  if (!segments.length) return value;

  const [head, ...rest] = segments;
  const child = buildPayloadExample(rest, value);

  if ((/^\d+$/).test(head)) {
    const array: Array<unknown> = new Array(Number(head) + 1).fill(null);
    array[Number(head)] = child;
    return array;
  }

  return { [head]: child };
}
